import { useEffect, useRef } from 'react';
import { divIcon, marker, point, } from 'leaflet';
import { useLeafletContext } from '@react-leaflet/core';
import { loc_equal } from 'shared/map/lib/utils';
import { getMarkerIcon } from './icon';
import './style.sass';
function createIconMarker(context, props) {
    const { points, size } = props;
    return divIcon({
        html: getMarkerIcon(points),
        className: 'marker-cluster',
        iconSize: point(size, size, true),
    });
}
function updateClusterMarker(context, instance, props, prevProps) {
    const icon = createIconMarker(context, prevProps);
    if (prevProps.size !== props.size) {
        const icon = createIconMarker(context, props);
        instance.setIcon(icon);
    }
    if (!loc_equal(prevProps.position, props.position))
        instance.setLatLng(props.position);
}
export const ClusterMarker = (props) => {
    const context = useLeafletContext();
    const elementRef = useRef();
    const propsRef = useRef(props);
    useEffect(() => {
        const icon = createIconMarker(context, props);
        const _marker = marker(props.position);
        _marker.on('click', (e) => props.onClick?.(e));
        _marker.setIcon(icon);
        elementRef.current = _marker;
        const container = context.layerContainer || context.map;
        container.addLayer(elementRef.current);
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, []);
    useEffect(() => {
        const container = context.layerContainer || context.map;
        if (elementRef.current) {
            updateClusterMarker(context, elementRef.current, props, propsRef.current);
            container.addLayer(elementRef.current);
        }
        return () => {
            if (elementRef.current)
                container.removeLayer(elementRef.current);
        };
    }, [props]);
    return null;
};
